// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__248Fp","productName":"Table_productName__1yhBw"};